// DEVE ser o 1º import — instala polyfills de runtime (Array/String.prototype.at) ANTES
// de qualquer código (LogRocket etc) rodar. Sem isso, o Chromium 85 da Tizen 6.5 crasha
// no `.at()` do logger do LogRocket. Vide src/utils/polyfills.ts.
import './utils/polyfills';
// 2º import — o corpo do módulo marca `bundle` sozinho. NÃO dá pra chamar `markBoot('bundle')`
// aqui: imports ESM são hoisted, então a chamada rodaria DEPOIS de todo o bundle já ter executado,
// medindo zero. Quem marca é o próprio módulo, no ponto em que é avaliado.
import { markBoot } from './utils/bootTiming';
// Carimba o início do PROCESSO (sessionStorage). Tem que ser cedo: é o que
// distingue "recarregou a página" de "o processo morreu e subiu de novo" —
// vide utils/uptime.ts.
import { markProcessStart } from './utils/uptime';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { logRingBuffer } from './services/logging/LogRingBuffer';
import { installCrashCapture } from './services/logging/crashCapture';

// Captura console.* num ring buffer em memória (capacity 500) antes de
// qualquer outro código rodar — garante que mesmo logs do boot da app
// fiquem disponíveis pro comando remoto logs:tail da Visualização Interativa.
logRingBuffer.init();

// Persiste erros globais (window.onerror, unhandledrejection) no
// localStorage pra ler no próximo boot. Crítico em Tizen consumer onde
// não temos acesso a sdb dlog e o app crashou sem deixar pista.
installCrashCapture();

const rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
  // Delta `bundle`→`react` = custo de avaliar o bundle (1,42 MB num só chunk). É a hipótese nº 1
  // pro 1,18s do reload; esta marca é o que confirma ou derruba.
  markProcessStart();
  markBoot('react');
}
